import { WithStyles } from '@material-ui/core';
import grey from '@material-ui/core/colors/grey';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import * as React from 'react';
import { connect } from 'react-redux';
import { StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';

import { ICareerClass, ICareerInfo, ICurriculumInfo } from '../actions/search';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ImstatScenarioFactory, {
	IFetchApplicationStatusDataParam,
} from '../scenario/ImstatScenarioFactory';
import SearchScenarioFactory from '../scenario/SearchScenarioFactory';
const styles = (theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
			width: 'auto',
		},
		cellItemName: {
			backgroundColor: grey[300],
			textAlign: 'right',
		},
		cellItemSubName: {
			maxWidth: '100px',
			textAlign: 'left',
		},
		cellItemSubValue: {
			textAlign: 'left',
			wordWrap: 'break-word',
		},
		cellItemValue: {
			textAlign: 'left',
			wordWrap: 'break-word',
		},
		flex: {
			flex: 1,
		},
		paper: {
			minWidth: '700px',
		},
		root: {
			flexGrow: 1,
			padding: 18,
		},
		table: {
			tableLayout: 'fixed',
		},
		wrapDiv: {
			margin: '10px',
		},
	});

interface IRouteParams {
	career_id: string;
	class_id: string;
	apl_type: string;
	curriculum_flg: string;
}

// tslint:disable-next-line: no-empty-interface
interface IRouteState {
	// nothing
}

interface IState {
	careerTitle: string;
	classTitle: string;
	curriculumFlg: boolean;
}

/**
 * 申請内容
 */
class ApplicationStatus extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);

		this.state = {
			careerTitle: '',
			classTitle: '',
			curriculumFlg: false,
		};
		if (this.props.careerID) {
			this.openApplicationStatus();
		}
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		if (!this.props.match || !this.props.match.params) {
			return;
		}

		const careerID = this.props.match.params.career_id;
		const classID = this.props.match.params.class_id;
		const aplType = this.props.match.params.apl_type;
		const curriculumFlg =
			this.props.match.params.curriculum_flg === '1' ? true : false;

		const fetchDataELearning = (
			careerInfo: ICareerInfo,
			careerClasses: ICareerClass[]
		) => {
			for (const cls of careerClasses) {
				if (cls.classID === classID) {
					this.setState({
						careerTitle: careerInfo.careerTitle || '',
						classTitle: cls.className || '',
						curriculumFlg,
					});
					this.props.fetchApplicationStatusData(this.props.token, {
						aplType,
						careerID,
						classID,
						curriculumFlg: 0,
						userAttr: this.props.userAttr,
					});
				}
			}
		};

		const fetchDataCurriculum = (curriculumInfo: ICurriculumInfo) => {
			this.setState({
				careerTitle: curriculumInfo.careerName || '',
				classTitle: '',
				curriculumFlg,
			});
			this.props.fetchApplicationStatusData(this.props.token, {
				aplType,
				careerID,
				classID: '',
				curriculumFlg: 1,
				userAttr: this.props.userAttr,
			});
		};

		if (!curriculumFlg) {
			this.props
				.doFetchCareerDetail(this.props.token, careerID)
				.then(data =>
					fetchDataELearning(data.careerInfo, data.careerClasses)
				);
		} else {
			this.props
				.doFetchCurriculumDetail(this.props.token, careerID)
				.then(data => fetchDataCurriculum(data.curriculumInfo));
		}
	}

	public openApplicationStatus() {
		const careerID = this.props.careerID;
		const classID = this.props.classID;
		const aplType = this.props.apllType;
		const curriculumFlg = this.props.curriculumFlg === '1' ? true : false;

		const fetchDataELearning = (
			careerInfo: ICareerInfo,
			careerClasses: ICareerClass[]
		) => {
			for (const cls of careerClasses) {
				if (cls.classID === classID) {
					this.setState({
						careerTitle: careerInfo.careerTitle || '',
						classTitle: cls.className || '',
						curriculumFlg,
					});
					this.props.fetchApplicationStatusData(this.props.token, {
						aplType,
						careerID,
						classID,
						curriculumFlg: 0,
						userAttr: this.props.userAttr,
					});
				}
			}
		};

		const fetchDataCurriculum = (curriculumInfo: ICurriculumInfo) => {
			this.setState({
				careerTitle: curriculumInfo.careerName || '',
				classTitle: '',
				curriculumFlg,
			});
			this.props.fetchApplicationStatusData(this.props.token, {
				aplType,
				careerID,
				classID: '',
				curriculumFlg: 1,
				userAttr: this.props.userAttr,
			});
		};

		if (!curriculumFlg) {
			this.props
				.doFetchCareerDetail(this.props.token, careerID)
				.then(data =>
					fetchDataELearning(data.careerInfo, data.careerClasses)
				);
		} else {
			this.props
				.doFetchCurriculumDetail(this.props.token, careerID)
				.then(data => fetchDataCurriculum(data.curriculumInfo));
		}
	}

	public render() {
		const { classes, data } = this.props;
		const { careerTitle, classTitle, curriculumFlg } = this.state;

		// 承認者情報
		let approvalNeedCnt = 0;
		let approval1Need: boolean = false;
		let approval2Need: boolean = false;
		let approval4Need: boolean = false;
		if (data.ph1_ApprovalNeedFlg && data.ph1_ApprovalNeedFlg === 1) {
			approvalNeedCnt++;
			approval1Need = true;
		}
		if (data.ph2_ApprovalNeedFlg && data.ph2_ApprovalNeedFlg === 1) {
			approvalNeedCnt++;
			approval2Need = true;
		}
		if (data.ph4_ApprovalNeedFlg && data.ph4_ApprovalNeedFlg === 1) {
			approvalNeedCnt++;
			approval4Need = true;
		}

		// 開催期間
		let kaisaiKikan = data.kaisaiKikan;
		if (kaisaiKikan === 'クラス指定なし') {
			kaisaiKikan = i18n.t(kaisaiKikan, {
				ns: 'force',
			});
		} else if (kaisaiKikan && kaisaiKikan.indexOf('～') !== -1) {
			kaisaiKikan = kaisaiKikan.replace(
				'～',
				i18n.t('～', {
					ns: 'force',
				})
			);
		}
		// 申込状況
		let mousikomiStatus = data.mousikomiStatus;
		if (
			mousikomiStatus === 'クラス指定なし' ||
			mousikomiStatus === '定員未設定'
		) {
			mousikomiStatus = i18n.t(mousikomiStatus, {
				ns: 'force',
			});
		} else if (mousikomiStatus && mousikomiStatus.indexOf('/') !== -1) {
			mousikomiStatus =
				i18n.t(mousikomiStatus.substring(0, 2), {
					ns: 'force',
				}) +
				mousikomiStatus.substring(2, mousikomiStatus.length).replace(
					'/定員',
					i18n.t('/定員', {
						ns: 'force',
					})
				);
		}
		return (
			<div className={classes.root}>
				<div className={classes.wrapDiv}>
					<Paper className={classes.paper}>
						<Table className={classes.table}>
							<colgroup>
								<col width="20%" />
								<col width="20%" />
							</colgroup>
							<TableBody>
								<TableRow>
									<TableCell
										className={classes.cellItemName}
										size="small"
									>
										{!curriculumFlg &&
											i18n.t('ApplicationStatus_0001')}
										{curriculumFlg &&
											i18n.t('ApplicationStatus_0002')}
									</TableCell>
									<TableCell
										className={classes.cellItemValue}
										colSpan={2}
									>
										{careerTitle}
									</TableCell>
								</TableRow>
								{!curriculumFlg && (
									<TableRow>
										<TableCell
											className={classes.cellItemName}
											size="small"
										>
											{i18n.t('ApplicationStatus_0003')}
										</TableCell>
										<TableCell
											className={classes.cellItemValue}
											colSpan={2}
										>
											{classTitle === '個別指定クラス' ||
											classTitle === '個別実施期間'
												? i18n.t(classTitle, {
														ns: 'force',
												  })
												: classTitle}
										</TableCell>
									</TableRow>
								)}
								{!curriculumFlg && (
									<TableRow>
										<TableCell
											className={classes.cellItemName}
											size="small"
										>
											{i18n.t('ApplicationStatus_0004')}
										</TableCell>
										<TableCell
											className={classes.cellItemValue}
											colSpan={2}
										>
											{kaisaiKikan}
										</TableCell>
									</TableRow>
								)}
								{!curriculumFlg && (
									<TableRow>
										<TableCell
											className={classes.cellItemName}
											size="small"
										>
											{i18n.t('ApplicationStatus_0005')}
										</TableCell>
										<TableCell
											className={classes.cellItemValue}
											colSpan={2}
										>
											{mousikomiStatus}
										</TableCell>
									</TableRow>
								)}
								<TableRow>
									<TableCell
										className={classes.cellItemName}
										size="small"
									>
										{i18n.t('ApplicationStatus_0006')}
									</TableCell>
									<TableCell
										className={classes.cellItemValue}
										colSpan={2}
									>
										{data.reason}
									</TableCell>
								</TableRow>
								{approval1Need && (
									<TableRow>
										<TableCell
											rowSpan={approvalNeedCnt}
											className={classes.cellItemName}
											size="small"
										>
											{i18n.t('ApplicationStatus_0007')}
										</TableCell>
										<TableCell
											className={classes.cellItemSubName}
										>
											{i18n.t('ApplicationStatus_0008')}
										</TableCell>
										<TableCell
											className={classes.cellItemSubValue}
										>
											{data.ph1_ApproverString &&
												i18n.t(
													data.ph1_ApproverString,
													{ ns: 'force' }
												)}
										</TableCell>
									</TableRow>
								)}
								{approval2Need && (
									<TableRow>
										<TableCell
											className={classes.cellItemSubName}
											size="small"
										>
											{i18n.t('ApplicationStatus_0009')}
										</TableCell>
										<TableCell
											className={classes.cellItemSubValue}
										>
											{data.ph2_ApproverString &&
												i18n.t(
													data.ph2_ApproverString,
													{ ns: 'force' }
												)}
										</TableCell>
									</TableRow>
								)}
								{approval4Need && (
									<TableRow>
										{!approval1Need && (
											<TableCell
												className={classes.cellItemName}
												size="small"
											>
												{i18n.t(
													'ApplicationStatus_0010'
												)}
											</TableCell>
										)}
										<TableCell
											className={classes.cellItemSubName}
										>
											{i18n.t('ApplicationStatus_0011')}
										</TableCell>
										<TableCell
											className={classes.cellItemSubValue}
										>
											{data.ph4_ApproverString &&
												i18n.t(
													data.ph4_ApproverString,
													{ ns: 'force' }
												)}
										</TableCell>
									</TableRow>
								)}
								<TableRow>
									<TableCell
										className={classes.cellItemName}
										size="small"
									>
										{i18n.t('ApplicationStatus_0012')}
									</TableCell>
									<TableCell
										className={classes.cellItemValue}
										colSpan={2}
									>
										{data.approvalStatus &&
											i18n.t(data.approvalStatus, {
												ns: 'force',
											})}
									</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</Paper>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state: IRootState) => ({
	// onGoingCurriculum: state.imstat.onGoingCurriculum,
	// onGoingELearning: state.imstat.onGoingELearning,
	// resultCurriculum: state.imstat.resultCurriculum,
	// resultELearning: state.imstat.resultELearning,
	careerDetailDialog: state.imstat.careerDetailDialog,
	data: state.imstat.applicationStatus.data,
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	doFetchCareerDetail: (token: string, careerID: string) => {
		const s = SearchScenarioFactory.createDoFetchCareerDetail(
			dispatch,
			token,
			true
		);
		return s.run(careerID);
	},
	doFetchCurriculumDetail: (token: string, careerID: string) => {
		const s = SearchScenarioFactory.createDoFetchCurriculumDetail(
			dispatch,
			token
		);
		return s.run(careerID);
	},
	fetchApplicationStatusData: (
		token: string,
		arg: IFetchApplicationStatusDataParam
	) => {
		const s = ImstatScenarioFactory.createFetchApplicationStatusData(
			dispatch,
			token
		);
		s.run(arg);
	},
});

export interface IApplicationStatusProps {
	careerID: string;
	classID: string;
	apllType: string;
	curriculumFlg: string;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> &
	RouteComponentProps<IRouteParams, StaticContext, IRouteState> &
	IApplicationStatusProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ApplicationStatus);

const Styled = withStyles(styles)(Connected);
const Export: React.ComponentType<IApplicationStatusProps> = Styled;

export default Export;



// WEBPACK FOOTER //
// ./src/containers/ApplicationStatus.tsx